import { IntegrationsStatusEnum } from 'types/integrations';
import useUserPeppolIntegration from './useUserPeppolIntegration';
import useIsPeppolPreVerified from './useIsPeppolPreVerified';

const usePeppolNudge = () => {
  const { data, isSuccess } = useUserPeppolIntegration();
  const isPeppolPreVerified = useIsPeppolPreVerified();

  if (!isSuccess) return false;

  return (
    data?.status === IntegrationsStatusEnum.verification_required ||
    (!data && isPeppolPreVerified)
  );
};

export default usePeppolNudge;
